import { createContext, useState, useCallback } from 'react';

export const ToastContext = createContext();
export const ToastProvider = ({ children }) => {
  const [message, setMessage] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const showToast = useCallback((message, position) => {
    setMessage(message);
    setPosition(position);
    setIsVisible(true);
    setTimeout(() => setIsVisible(false), 1000);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {isVisible && <div className="toast" style={{ top: position.top, left: position.left }}>{message}</div>}
    </ToastContext.Provider>
  );
};


